import { useAuthStore } from '@/stores/authStore'
import { computed } from 'vue'

export const useCheckUserRights = () => {
  const authStore = useAuthStore()

  const isCexCexAdvanced = computed(() => 'futures_advanced' in authStore.currentAccessList)
  const isCexCex = computed(() => 'futures' in authStore.currentAccessList)
  const isCexCexFree = computed(() => 'futures_free' in authStore.currentAccessList)

  const isDexCexAdvanced = computed(() => 'dex_cex_advanced' in authStore.currentAccessList)
  const isDexCex = computed(() => 'dex_cex' in authStore.currentAccessList)
  const isDexCexFree = computed(() => 'dex_cex_free' in authStore.currentAccessList)

  return {
    isCexCexAdvanced,
    isCexCexFree,
    isDexCexAdvanced,
    isDexCexFree,
    isCexCex,
    isDexCex,
  }
}
